import type { Component } from 'solid-js'

const UserDirectorySkeletonRow: Component = () => (
  <tr class="animate-pulse">
    <td class="px-4 py-3">
      <div class="flex items-center gap-2">
        <div class="h-8 w-8 flex-shrink-0 rounded-full bg-gray-200" />
        <div class="h-4 w-32 rounded bg-gray-200" />
      </div>
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-40 rounded bg-gray-200" />
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-24 rounded bg-gray-200" />
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-28 rounded bg-gray-200" />
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-24 rounded bg-gray-200" />
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-20 rounded bg-gray-200" />
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-24 rounded bg-gray-200" />
    </td>
    <td class="px-4 py-3">
      <div class="h-4 w-16 rounded bg-gray-200" />
    </td>
  </tr>
)

export default UserDirectorySkeletonRow
